var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hadMonitor)?_c('div',[_c('dashboard-cards',{ref:"dashboardCards",attrs:{"useLocalPanels":"","extraParams":_vm.extraParams,"localPanels":_vm.localPanels}})],1):[_c('a-alert',{staticClass:"mb-2",attrs:{"message":_vm.$t('db.text_183'),"type":"warning"}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }